import { z } from 'zod';

export const CurrentUserDto = z.object({
  firstName: z.string(),
  lastName: z.string(),
});

export type TCurrentUserDto = z.infer<typeof CurrentUserDto>;
